import { isRequired } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (isRequired(values[`overview`] || '', true)) {
    errors[`overview`] = 'overviewIsRequired';
  }

  if (isRequired(values[`cancellation`] || '', true)) {
    errors[`cancellation`] = 'cancellationIsRequired';
  }

  return errors;
};

export default validate;
